<template>
  <a class="brand" href="https://mrdn.world" target="_blank" rel="noopener" aria-label="Méridien — mrdn.world">
    <img src="/meridien-logo.svg" alt="" width="38" height="23" class="brand__logo" />
    <span class="brand__text">
      <span class="brand__by">a</span>
      <span class="brand__name">Méridien</span>
      <span class="brand__by">project</span>
    </span>
  </a>
</template>

<style scoped>
.brand {
  position: fixed;
  top: clamp(0.9rem, 2.2vh, 1.6rem);
  left: clamp(0.9rem, 2.2vw, 1.6rem);
  z-index: 80;
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0.8rem 0.45rem 0.6rem;
  background: rgba(5, 5, 5, 0.78);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 999px;
  text-decoration: none;
  color: #F4F1EA;
  transition: background 0.18s ease, border-color 0.18s ease;
}
.brand:hover {
  background: rgba(5, 5, 5, 0.92);
  border-color: rgba(161, 221, 0, 0.55);
}
.brand__logo {
  display: block;
  width: 26px;
  height: 16px;
  flex-shrink: 0;
}
.brand__text {
  font-family: 'Struve', sans-serif;
  font-weight: 500;
  font-size: 0.78rem;
  letter-spacing: 0.06em;
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  gap: 0.32em;
}
.brand__by {
  color: rgba(244, 241, 234, 0.55);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.72rem;
}
.brand__name { color: #FFF; font-weight: 700; }
@media (max-width: 540px) {
  .brand__by { display: none; }
}
</style>
